document.addEventListener('DOMContentLoaded', function () {
  const productGrid = document.querySelector('#product-grid');
  const loadMoreBtn = document.querySelector('.load-more.button, .load-more');

  if (!productGrid || !loadMoreBtn) {
    console.warn('Load more: missing product grid or button');
    return;
  }

  const spinner = loadMoreBtn.querySelector('.loading-overlay');
  let isLoading = false;

  const currentUrl = new URL(window.location.href);
  let currentPage = parseInt(currentUrl.searchParams.get('page') || '1', 10);

  let sentinel = document.querySelector('#collection-load-more-sentinel');
  if (!sentinel) {
    sentinel = document.createElement('div');
    sentinel.id = 'collection-load-more-sentinel';
    sentinel.style.width = '100%';
    sentinel.style.height = '1px';
    loadMoreBtn.parentNode.insertBefore(sentinel, loadMoreBtn);
  }

  function setLoadingState(loading) {
    if (spinner) spinner.style.display = loading ? 'flex' : 'none';
    loadMoreBtn.style.pointerEvents = loading ? 'none' : '';
    loadMoreBtn.style.opacity = loading ? '0.6' : '';
    loadMoreBtn.disabled = loading;
  }

  function buildNextUrl(page) {
    const url = new URL(window.location.href);
    url.searchParams.set('page', page);
    return url.toString();
  }

  async function loadMoreProducts() {
    if (isLoading || loadMoreBtn.style.display === 'none') return false;

    isLoading = true;
    setLoadingState(true);

    try {
      const nextPage = currentPage + 1;
      const nextUrl = buildNextUrl(nextPage);

      const response = await fetch(nextUrl, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch page ' + nextPage);
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const nextGrid = doc.querySelector('#product-grid');
      if (!nextGrid) {
        loadMoreBtn.style.display = 'none';
        return false;
      }

      const newItems = nextGrid.querySelectorAll(':scope > li, :scope > .grid__item, :scope > .column');
      if (!newItems.length) {
        loadMoreBtn.style.display = 'none';
        return false;
      }

      const existingHandles = new Set(
        Array.from(productGrid.querySelectorAll('a[href*="/products/"]')).map((a) => a.getAttribute('href'))
      );

      let appendedCount = 0;

      newItems.forEach((item) => {
        const productLink = item.querySelector('a[href*="/products/"]');
        const href = productLink ? productLink.getAttribute('href') : null;

        if (href && !existingHandles.has(href)) {
          productGrid.appendChild(item.cloneNode(true));
          existingHandles.add(href);
          appendedCount++;
        }
      });

      if (appendedCount === 0) {
        loadMoreBtn.style.display = 'none';
        return false;
      }

      currentPage = nextPage;
      return true;
    } catch (error) {
      console.error('Load more error:', error);
      return false;
    } finally {
      setLoadingState(false);
      isLoading = false;
    }
  }

  loadMoreBtn.addEventListener('click', function (e) {
    e.preventDefault();
    loadMoreProducts();
  });

  const observer = new IntersectionObserver(
    async function (entries) {
      const entry = entries[0];
      if (!entry.isIntersecting || isLoading || loadMoreBtn.style.display === 'none') return;

      observer.unobserve(sentinel);

      const loaded = await loadMoreProducts();

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (loadMoreBtn.style.display !== 'none') {
            observer.observe(sentinel);

            const rect = sentinel.getBoundingClientRect();
            if (rect.top < window.innerHeight + 200) {
              loadMoreProducts();
            }
          }
        });
      });
    },
    {
      root: null,
      rootMargin: '400px 0px',
      threshold: 0
    }
  );

  observer.observe(sentinel);
});
